import * as IoC from 'inversify';
import { registerQuery } from '@/app/tracking/common';
import { QueryStudentInfoTrackingQueryName } from '../api';
import { QueryStudentInfoTrackingQueryHandler } from './query-student-info-tracking-query-handler';

export const studentInfoCommonTrackingModule = new IoC.ContainerModule((bind) => {
  registerQuery(QueryStudentInfoTrackingQueryName,
                QueryStudentInfoTrackingQueryHandler, bind);
})
